import { TypePolicies } from '@apollo/client'

/**
 * How Apollo's cache identifies objects that carry no `id`.
 *
 * ENGG-10387 (code review): a `ConnectedSource` (`connectedSources`, a meeting
 * source's connection state) is one object per source key, read by two queries
 * on the Call Recorder page — the Avoma card's `GET_CONNECTED_SOURCES` and the
 * Gong card's `GET_GONG_SALES_ROOM_SOURCE`, which asks for `lookbackDays` too —
 * and written by `updateMeetingSourceSettings`. Keyed by `key`, every write
 * merges into the one record: the Avoma card's refetch no longer drops the
 * field only the Gong section reads (which made that section refetch and flash
 * "Loading"), and the save's own answer flips the Gong switch at once rather
 * than after the status read that follows it.
 */
export const cacheTypePolicies: TypePolicies = {
  ConnectedSource: { keyFields: ['key'] },
}
